import React, { useEffect, useRef } from 'react';
import { styled } from 'styled-components';
import { breakpoints } from '../../../../styled/utils';
import Text from '../../../Text';

interface BlogContentProps {
  content: string,
  summary: string,
}

const StyledBlogContent = styled.div`
  background-color: var(--color-white);
  padding-bottom: var(--space-xxl);
  padding-top: var(--baseline);

  > div,
  > div > div {
    column-gap: var(--gutter);
    display: grid;

    @media ${breakpoints.md} {
      grid-template-columns: repeat(8, 1fr);
    }

    @media ${breakpoints.xl} {
      grid-template-columns: repeat(8, 1fr);
    }

    > table,
    > pre,
    > iframe,
    > section,
    > div:first-child {
      @media ${breakpoints.md} {
        grid-column: span 8;
      }

      @media ${breakpoints.xl} {
        grid-column: span 8;
      }
    }

    > *:not(table):not(pre):not(iframe):not(section):not(div:first-child),
    > div > *:not(table):not(pre):not(iframe):not(section) {
      @media ${breakpoints.md} {
        grid-column: 2 / span 6;
      }

      @media ${breakpoints.xl} {
        grid-column: 2 / span 6;
      }
    }

    &.summary {
      margin-bottom: var(--baseline);
    }
  }
`;

export default function BlogContent({ content, summary }: BlogContentProps) {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (container.current) {
      const anchors = container.current.querySelectorAll('a');
      Array.from(anchors).forEach((link: HTMLAnchorElement) => {
        if (link && link.getAttribute('href')?.match(/^#.+$/)) {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            const id = link.getAttribute('href')?.slice(1);
            if (id) {
              const footnote = document.getElementById(id);
              if (footnote) {
                footnote.scrollIntoView({behavior: 'smooth', block: 'center'});
              }
            }
          });
        }
      });
    }
  }, [container.current]);

  return (
    <StyledBlogContent ref={container}>
      <div className="summary">
        <Text markdown options={{ forceWrapper: true, wrapper: 'strong' }} en={summary} />
      </div>
      <Text markdown en={content} />
    </StyledBlogContent>
  );
}
